import { z } from 'zod';

export const patientAddressFormSchema = z.object({
  postal_code1: z
    .string()
    .length(3, '郵便番号1は3桁にしてください。')
    .regex(/^[0-9]+$/, '郵便番号1は3桁にしてください。'),
  postal_code2: z
    .string()
    .length(4, '郵便番号2は4桁にしてください。')
    .regex(/^[0-9]+$/, '郵便番号2は4桁にしてください。'),
  address1: z
    .string()
    .trim()
    .min(1, '住所1は必須です。')
    .max(255, '255文字以内で入力してください'),
  address2: z
    .string()
    .trim()
    .min(1, '住所2は必須です。')
    .max(255, '255文字以内で入力してください'),
  address3: z.string().max(255).optional().nullable(),
  name: z.string().max(255).optional().nullable(),
  address2_hidden: z.boolean().optional().default(false),
  is_facility_resident: z.boolean().optional().default(true),
  address3_check: z.boolean().optional().default(false),
  is_special_area_addition: z.boolean().optional().default(false),
  is_default: z.boolean().optional().default(false),
});

export type PatientAddressFormData = z.infer<typeof patientAddressFormSchema>;
